import { Products } from "../../../models/models";
import { ActualProduct, MigratedProduct, MigratedProductColumnsTable } from "./model";

export function defColumnsDataTable(data: MigratedProduct[]): MigratedProductColumnsTable[] {
    return data.map((product) => ({
        ...product,
        isOpen: false,
    }));
}

export function defActualProducts(data: Products): ActualProduct[] {
    return data.map((product) => ({
        id: product.id,
        name: product.name,
    }));
}